import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getArchivioNewsPage = gql`
  ${seoFragment}
  query getArchivioNewsPage($slug: [String], $site: [String]) {
    archivioNewsPageEntries(site: $site) {
      ... on archivioNewsPage_Entry {
        id
        seo {
          ...SeoFragment
        }
      }
    }
    newsEntries(slug: $slug, site: $site) {
      ... on news_Entry {
        slug
        introNews {
          html
        }
        title
        sezioneContenutoPagina {
          ... on immagine_Entry {
            custom: immagine @transform(format: "webp", width: 740) {
              id
              url
              width
              height
              title
            }
          }
          ... on immagineTradotta_Entry {
            custom: immagineTradotta @transform(format: "webp", width: 1800) {
              id
              url
              width
              height
              title
            }
          }
        }
      }
    }
  }
`
